import { useDispatch, useSelector } from "react-redux";
import {
  setCalendarFormData,
  setCalendarFormFocus
} from "@/store/slices/components/calendar/CalendarSlice";
import { MAX_CHARS } from "../utils/constants";
import Trans from "@/components/shared/Trans"
import translations from '../calendarForm/calendarForm.trans.json'
import style from '../calendarForm/calendarForm.module.scss'

const staticFields = ['fullname', 'email', 'phone', 'comment']

export default function useCalendarInputs() {
  const dispatch = useDispatch()
  const { form } = useSelector(state => state.CalendarSlice)
  const filteredForm = Object.entries(form)
    .filter(([key]) => !staticFields.includes(key))
    .map(([key, value]) => ({ id: key, ...value }))

  const handleChange = (event, max) => {
    const key = event.target.dataset.field
    const value = event.target.value.slice(0, max);

    dispatch(setCalendarFormData({ key, subkey: 'value', value }))
  }

  const handleFocus = (event) => {
    const key = event.target.dataset.field
    dispatch(setCalendarFormFocus({ key, focused: true }))
  }

  const handleBlur = (event) => {
    const key = event.target.dataset.field
    dispatch(setCalendarFormFocus({ key, focused: false }))
  }

  const getListOfInputs = () => {
    const fullnameInput = {
      id: 'fullname',
      type: 'input',
      mode: 'text',
      labelText: Trans(translations, 'NameAndSurname'),
      placeholder: Trans(translations, 'JohnDoe'),
      classes: `${style.calendarFormInput}`,
      containerClasses: `${style.calendarFormField}`,
      inputWrapperClasses: `${style.calendarFormInputWrapper}`,
      maxLength: MAX_CHARS.FULLNAME,
    }

    const emailInput = {
      id: 'email',
      type: 'input',
      mode: 'text',
      labelText: Trans(translations, 'Email'),
      placeholder: Trans(translations, 'PlaceholderEmail'),
      classes: `${style.calendarFormInput}`,
      containerClasses: `${style.calendarFormField}`,
      inputWrapperClasses: `${style.calendarFormInputWrapper}`,
      maxLength: MAX_CHARS.EMAIL,
    }

    const phoneInput = {
      id: 'phone',
      type: 'input',
      mode: 'numeric',
      labelText: Trans(translations, 'Phone'),
      placeholder: Trans(translations, 'PlaceholderPhoneByCountry'),
      footerText: Trans(translations, 'IncludeTheCountryAndAreaCode'),
      classes: `${style.calendarFormInput}`,
      containerClasses: `${style.calendarFormField}`,
      inputWrapperClasses: `${style.calendarFormInputWrapper}`,
      maxLength: MAX_CHARS.PHONE,
    }

    const commentInput = {
      id: 'comment',
      type: 'textarea',
      mode: 'text',
      labelText: Trans(translations, 'VisitComments'),
      placeholder: Trans(translations, 'LetUsKnow'),
      classes: `${style.calendarFormTextarea}`,
      containerClasses: `${style.calendarFormField} ${style.calendarFormFieldTextarea}`,
      inputWrapperClasses: `${style.calendarTextareaWrapper}`,
      maxLength: MAX_CHARS.COMMENTS,
    }

    const customInputs = filteredForm
      .filter(field => field.needed)
      .map(field => ({
        id: field.id,
        type: 'input',
        mode: 'text',
        labelText: field.id,
        placeholder: '',
        classes: `${style.calendarFormInput}`,
        containerClasses: `${style.calendarFormField}`,
        inputWrapperClasses: `${style.calendarFormInputWrapper}`,
        maxLength: MAX_CHARS.CUSTOM,
      }))

    const listOfInputs = []
    const grouped = [emailInput, phoneInput, ...customInputs]
      .filter(field => form[field.id]?.needed)

    if (form.fullname.needed) listOfInputs.push(fullnameInput);
    if (grouped.length > 0) {
      listOfInputs.push({
        group: true,
        data: [...grouped],
      })
    }
    if (form.comment.needed) listOfInputs.push(commentInput)
    
    return listOfInputs
  }

  const handlers = {
    handleChange,
    handleFocus,
    handleBlur
  }

  return {
    listOfInputs: getListOfInputs(),
    handlers
  }
}
